import ReactDOM from 'react-dom';

type PreloadPriority = 'high' | 'low' | 'auto';

export function preloadImage(
  src: string | null | undefined,
  fetchPriority: PreloadPriority = 'auto',
) {
  if (!src) return;
  ReactDOM.preload(src, { as: 'image', fetchPriority });
}

export function preloadImages(
  srcs: ReadonlyArray<string | null | undefined>,
  fetchPriority: PreloadPriority = 'auto',
) {
  for (const src of srcs) {
    preloadImage(src, fetchPriority);
  }
}
